import { render, staticRenderFns } from "./DedicationItems.vue?vue&type=template&id=654dd8a3&scoped=true&"
import script from "./DedicationItems.vue?vue&type=script&lang=js&"
export * from "./DedicationItems.vue?vue&type=script&lang=js&"
import style0 from "./DedicationItems.vue?vue&type=style&index=0&id=654dd8a3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "654dd8a3",
  null
  
)

export default component.exports